import React from "react";
import PropTypes from "prop-types";
import {
  InfoTitle,
} from "../style";
import Heading from './Heading';

export default function PermissionToPublish({
    title = "Permission to publish",
    edit,
    handleEdit,
    publish
}) {
    return (
      <div>
        <Heading id="btnPermissiontopublish" title={title} edit={edit} handleEdit={handleEdit} />
        <InfoTitle wrap>
        You have {publish ? "" : "not"} allowed the organization to make public the details of the grant.
        </InfoTitle>
      </div>
    );
  };
  
PermissionToPublish.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
  handleEdit: PropTypes.func,
  publish: PropTypes.bool
};